<template>
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="text-dark text-bold font-large-2 mb-1">
          กำลังโหลด...
          <b-spinner
            style="width: 3rem; height: 3rem;"
            label="Busy"
          ></b-spinner>
        </h2>
        <p class="text-dark font-large-1 mb-2">
          กรุณารอสักครู่
        </p>

        <!-- <b-button
          variant="primary"
          class="mb-2 mt-3 btn-sm-block font-medium-5"
          :to="{ path: '/' }"
        >
          Go to Login Page
        </b-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index";
import router from "@/router";
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
export default {
  setup() {
    const { decodeParamToken } = useDecodeToken();
    let token = null;
    let decodeToken = null;

    const redirectUrl = (action, token) => {
      switch (action) {
        case "Password_Recovery":
          return router
            .replace({ path: "/new-password", query: { token: token } })
            .catch(() => {});
        case "Forget_Password":
          return router
            .replace({ path: "/forget-password", query: { token: token } })
            .catch(() => {});
        case "Error":
        case "Expired":
          return router
            .replace({
              path: "/error",
              query: { token: token },
            })
            .catch(() => {});
        default:
          return router
            .replace({
              path: "/login",
              query: { brandRef: decodeToken.brand_ref },
            })
            .catch(() => {});
      }
    };

    onBeforeMount(() => {
      token = router.currentRoute.query.token;
      if (decodeParamToken()) {
        decodeToken = decodeParamToken();
        //redirect url
        if (decodeToken?.action) redirectUrl(decodeToken.action, token);
      }
    });
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
